module.exports = __webpack_public_path__ + "static/img/0545_6.1d7b39b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0545_6.jpg
// module id = F6Nn
// module chunks = 1